var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nx-app",attrs:{"id":"app"}},[_c('router-view'),(_vm.website.waterMarkEnable)?_c('water-mark'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }